import React, { useEffect, useState } from "react";

export const FloatingContinueBtn = ({ show, allow, onClick }) => {
  const [keyboardHeight, setKeyboardHeight] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    if (!show) {
      setIsVisible(false);
      setKeyboardHeight(0);
      return;
    }
    
    // 监听 visualViewport 变化来检测键盘高度
    const handleResize = () => {
      if (window.visualViewport) {
        const viewportHeight = window.visualViewport.height;
        const windowHeight = window.innerHeight;
        const calculatedKeyboardHeight = windowHeight - viewportHeight;
        setKeyboardHeight(calculatedKeyboardHeight > 0 ? calculatedKeyboardHeight : 0);
        
        // 只有当键盘高度 > 0 时才显示按钮
        setIsVisible(calculatedKeyboardHeight > 0);
      }
    };
    
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', handleResize);
      
      // 延迟检查，等待键盘弹起
      const checkTimer = setTimeout(() => {
        handleResize();
      }, 300);
      
      return () => {
        clearTimeout(checkTimer);
        window.visualViewport.removeEventListener('resize', handleResize);
      };
    }
  }, [show]);
  
  if (!isVisible || keyboardHeight === 0) return null;
  
  const bottomPosition = keyboardHeight + 12;
  
  return (
    <div 
      className="fixed right-[12px] z-[9999] pointer-events-none transition-all duration-[300ms] opacity-100"
      style={{ bottom: `${bottomPosition}px` }}
    >
      <button 
        className={`
          pointer-events-auto
          px-[24px] py-[12px]
          rounded-[24px]
          text-[16px] font-[600] text-white
          transition-transform duration-[200ms]
          active:scale-[0.95]
          select-none
          ${allow 
            ? 'bg-[#1FC81D] cursor-pointer' 
            : 'bg-[#D3DDCB] cursor-not-allowed opacity-[0.6]'
          }
        `}
        onClick={onClick}
        disabled={!allow}
      >
        Continue
      </button>
    </div>
  );
};
